import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, RequireRole } from "@/lib/auth";

import PublicLayout from "@/pages/public/PublicLayout";
import Home from "@/pages/public/Home";
import About from "@/pages/public/About";
import Services from "@/pages/public/Services";
import Industries from "@/pages/public/Industries";
import HowItWorks from "@/pages/public/HowItWorks";
import Contact from "@/pages/public/Contact";
import Legal from "@/pages/public/Legal";
import ClientLogin from "@/pages/public/ClientLogin";
import ResetPassword from "@/pages/public/ResetPassword";

import ClientLayout from "@/pages/client/ClientLayout";
import Dashboard from "@/pages/client/Dashboard";
import Campaigns from "@/pages/client/Campaigns";
import CampaignDetail from "@/pages/client/CampaignDetail";
import Locations from "@/pages/client/Locations";
import Analytics from "@/pages/client/Analytics";
import Reports from "@/pages/client/Reports";
import CalendarPage from "@/pages/client/CalendarPage";
import Profile from "@/pages/client/Profile";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminClients from "@/pages/admin/AdminClients";
import AdminCampaigns from "@/pages/admin/AdminCampaigns";
import AdminGeofences from "@/pages/admin/AdminGeofences";
import GeofenceBuilder from "@/pages/admin/GeofenceBuilder";
import AdminCreatives from "@/pages/admin/AdminCreatives";
import AdminAudit from "@/pages/admin/AdminAudit";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminContacts from "@/pages/admin/AdminContacts";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Legal kind="privacy" />} />
              <Route path="/terms" element={<Legal kind="terms" />} />
              <Route path="/cookies" element={<Legal kind="cookies" />} />
            </Route>

            <Route path="/login" element={<ClientLogin />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/admin/login" element={<AdminLogin />} />

            <Route path="/portal" element={<RequireRole role="client"><ClientLayout /></RequireRole>}>
              <Route index element={<Dashboard />} />
              <Route path="campaigns" element={<Campaigns />} />
              <Route path="campaigns/:id" element={<CampaignDetail />} />
              <Route path="locations" element={<Locations />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="reports" element={<Reports />} />
              <Route path="calendar" element={<CalendarPage />} />
              <Route path="profile" element={<Profile />} />
            </Route>

            <Route path="/admin" element={<RequireRole role="admin"><AdminLayout /></RequireRole>}>
              <Route index element={<AdminDashboard />} />
              <Route path="clients" element={<AdminClients />} />
              <Route path="campaigns" element={<AdminCampaigns />} />
              <Route path="geofences" element={<AdminGeofences />} />
              <Route path="geofence-builder" element={<GeofenceBuilder />} />
              <Route path="creatives" element={<AdminCreatives />} />
              <Route path="contacts" element={<AdminContacts />} />
              <Route path="audit-logs" element={<AdminAudit />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
